import React from "react";
import ModalFooter from "./modalFooter";
import ModalHeader from "./modalHeader";
import type { Props as rawModalProps } from "./rawModal";
import RawModal from "./rawModal";

export type Props = rawModalProps & {
  title?: string;
  sub?: string;
  onSubmit?: () => void;
  noHeader?: boolean;
  noFooter?: boolean;
};

const Modal: React.FC<Props> = ({
  children,
  onSubmit,
  title,
  sub,
  noHeader,
  noFooter,
  onClose,
  ...restProps
}) => {
  return (
    <RawModal {...restProps} onClose={onClose}>
      {!noHeader && (
        <ModalHeader
          onClose={() => {
            onClose && onClose();
          }}
          title={title}
          sub={sub}
        />
      )}
      <div className="res-modal__content">{children}</div>
      {!noFooter && (
        <ModalFooter
          onSubmit={() => {
            onSubmit && onSubmit();
          }}
          onClose={() => {
            onClose && onClose();
          }}
        />
      )}
    </RawModal>
  );
};

export default Modal;
